import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';
import FAQItem from '../contact-support/components/FAQItem';
import ContactSection from '../../components/ContactSection';

const TempoTravellerDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { route } = location?.state || {};
  const [selectedDuration, setSelectedDuration] = useState('1D');
  const [selectedCar, setSelectedCar] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!route) {
      navigate('/homepage');
    }
  }, [route, navigate]);

  const durations = ['1D', '1N 2D', '2N 3D'];

  const tempoTravellerOptions = [
  {
    id: 1,
    name: 'Tempo Traveller',
    luggage: 8,
    seats: 12,
    price: 14000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f41fd6f-1768440186961.png",
    alt: 'White tempo traveller 12 seater minibus for group travel'
  },
  {
    id: 2,
    name: 'Tempo Traveller',
    luggage: 15,
    seats: 17,
    price: 15000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_114e4d671-1768440186864.png",
    alt: 'White tempo traveller 17 seater for large group travel'
  },
  {
    id: 3,
    name: 'Tempo Traveller',
    luggage: 15,
    seats: 25,
    price: 19000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
    alt: 'Extra large tempo traveller 25 seater for large group travel'
  },
  {
    id: 4,
    name: 'Force Urbania',
    luggage: 16,
    seats: 16,
    price: 19000,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
    alt: 'Force Urbania luxury van 16 seater with premium interiors'
  }];


  const tempoRoutes = [
  { destination: 'Chandigarh To Amritsar', price: '₹ 14000/-' },
  { destination: 'Chandigarh To Dalhousie', price: '₹ 33600/-' },
  { destination: 'Chandigarh To Delhi Airport', price: '₹ 14000/-' },
  { destination: 'Chandigarh To Delhi', price: '₹ 14000/-' },
  { destination: 'Chandigarh To Dharamshala', price: '₹ 21000/-' },
  { destination: 'Chandigarh To Kasol', price: '₹ 22400/-' },
  { destination: 'Chandigarh To Khatu Shyam', price: '₹ 30800/-' },
  { destination: 'Chandigarh To Mathura', price: '₹ 22400/-' },
  { destination: 'Chandigarh To Mussoorie', price: '₹ 22400/-' },
  { destination: 'Chandigarh To Salasar Balaji', price: '₹ 30800/-' },
  { destination: 'Chandigarh To Shimla', price: '₹ 16800/-' },
  { destination: 'Chandigarh To Takhat Sachkhand Sri Hazur Sahib', price: '₹ 123200/-' }];


  const faqData = [
  {
    question: 'How many seats in Tempo Traveller?',
    answer: 'We offer Tempo Travellers with various seating capacities: 12-seater, 17-seater, and 25-seater options. Force Urbania is available with 16 seats. All vehicles are spacious and comfortable for long journeys.'
  },
  {
    question: 'Can I book a Tempo Traveller for a single day?',
    answer: 'Yes, absolutely! We offer flexible booking options including single day (1D), one night two days (1N 2D), and two nights three days (2N 3D) packages. You can choose the duration that best suits your travel needs.'
  },
  {
    question: 'Are Tempo Travellers available for outstation?',
    answer: 'Yes, our Tempo Travellers are specifically designed for outstation trips. We cover all major destinations from Chandigarh including Amritsar, Dalhousie, Delhi, Dharamshala, Shimla, Manali, and many more hill stations and pilgrimage sites.'
  },
  {
    question: 'Does the Tempo Traveller have AC?',
    answer: 'Yes, all our Tempo Travellers come equipped with air conditioning to ensure a comfortable journey regardless of weather conditions. The AC system is well-maintained and regularly serviced.'
  },
  {
    question: 'What are the amenities in Tempo Traveller?',
    answer: 'Our Tempo Travellers include: Air conditioning, comfortable push-back seats, ample luggage space, music system, charging points, first aid kit, and experienced drivers. Force Urbania offers additional premium amenities.'
  },
  {
    question: 'How to book a Tempo Traveller?',
    answer: 'Booking is simple! Select your preferred vehicle from the options above, click "Select Car", fill in your travel details, and complete the payment. You can also call us at +91-7998666660 or WhatsApp for instant booking assistance.'
  },
  {
    question: 'Will I get a driver with a Tempo Traveller?',
    answer: 'Yes, all Tempo Traveller bookings include an experienced and verified driver. Driver charges, toll taxes, and parking fees are included in the package price. The driver is well-versed with all North Indian routes.'
  },
  {
    question: 'What is the cancellation policy for a Tempo Traveller?',
    answer: 'Free cancellation up to 48 hours before scheduled departure. Cancellations within 48-24 hours incur 25% charge. Within 24 hours: 50% charge. No-shows are charged 100%. Refunds processed within 5-7 business days.'
  },
  {
    question: 'Is there a mileage limit on Tempo Traveller rentals?',
    answer: 'Our packages include specific mileage based on the route. For custom trips, we offer flexible mileage options. Extra kilometers are charged at nominal rates. All details are transparently shared before booking confirmation.'
  },
  {
    question: 'Is there a special package for long term rental service?',
    answer: 'Yes, we offer attractive long-term rental packages for corporate clients, tour operators, and extended family trips. Contact our team at +91-7998666660 for customized long-term rental quotes and special discounts.'
  },
  {
    question: 'Are these Tempo Travellers well maintained?',
    answer: 'Absolutely! All our Tempo Travellers undergo regular maintenance checks and thorough cleaning before every trip. We maintain the highest standards of vehicle hygiene and mechanical fitness to ensure passenger safety and comfort.'
  },
  {
    question: 'Can I use Tempo Traveller for airport transfers?',
    answer: 'Yes, our Tempo Travellers are perfect for group airport transfers. We provide timely pickup and drop services for Chandigarh Airport, Delhi Airport, and Amritsar Airport. Ideal for corporate groups and family travel.'
  },
  {
    question: 'What is the cost of tempo traveller rent from Chandigarh to Amritsar?',
    answer: 'The starting price for Chandigarh to Amritsar Tempo Traveller is ₹14,000/- for a 12-seater vehicle. Prices vary based on vehicle type (17-seater, 25-seater, Force Urbania) and duration. All prices are inclusive of taxes, driver charges, and toll fees.'
  }];


  const handleSelectCar = (car) => {
    setSelectedCar(car?.id);
    navigate('/tempo-traveller-booking', {
      state: {
        route,
        vehicle: car,
        serviceType: 'Tempo Traveller',
        duration: selectedDuration
      }
    });
  };

  const handleRouteClick = (routeItem) => {
    const [from, to] = routeItem?.destination?.split(' To ');
    navigate('/tempo-traveller-details', {
      state: {
        route: {
          from: from,
          to: to
        }
      }
    });
    window.scrollTo(0, 0);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-16 lg:pt-20">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center">
              Chandigarh to {route?.to} Tempo Traveller
            </h1>
            <p className="text-center text-white/90 mt-4 text-lg">Advait Tour and Travels</p>
          </div>
        </div>

        {/* Duration Selection Tabs */}
        <div className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex flex-wrap gap-2 justify-center">
              {durations?.map((duration) =>
              <button
                key={duration}
                onClick={() => setSelectedDuration(duration)}
                className={`px-6 md:px-16 py-3 rounded-full font-semibold text-sm md:text-base transition-all duration-200 ${
                selectedDuration === duration ?
                'bg-yellow-400 text-gray-900 shadow-md' :
                'bg-white text-gray-700 border border-gray-300 hover:border-yellow-400'}`
                }>

                  {duration}
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Vehicle Selection Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
          <div className="space-y-6">
            {tempoTravellerOptions?.map((car) =>
            <div
              key={car?.id}
              className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden">

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 p-4 md:p-6 items-center">
                  {/* Car Image */}
                  <div className="md:col-span-2">
                    <div className="w-full h-24 md:h-28 flex items-center justify-center">
                      <Image
                      src={car?.image}
                      alt={car?.alt}
                      className="w-full h-full object-contain" />

                    </div>
                  </div>

                  {/* Car Details */}
                  <div className="md:col-span-3">
                    <p className="text-xs text-gray-500 uppercase mb-1">Car Type</p>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900">{car?.name}</h3>
                    <button className="text-sm text-green-600 font-medium mt-1 hover:underline">
                      More Details
                    </button>
                  </div>

                  {/* Luggage */}
                  <div className="md:col-span-2 flex items-center gap-2">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon name="Briefcase" size={20} className="text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">{car?.luggage} Luggage</p>
                    </div>
                  </div>

                  {/* Seats */}
                  <div className="md:col-span-2 flex items-center gap-2">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon name="Users" size={20} className="text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">{car?.seats} Seats</p>
                    </div>
                  </div>

                  {/* Price */}
                  <div className="md:col-span-2 text-center md:text-right">
                    <p className="text-2xl md:text-3xl font-bold text-green-600">
                      ₹{car?.price?.toLocaleString('en-IN')}/-
                    </p>
                    <p className="text-xs text-gray-500">Inc. of Taxes*</p>
                  </div>

                  {/* Select Button */}
                  <div className="md:col-span-1 flex justify-center md:justify-end">
                    <button
                    onClick={() => handleSelectCar(car)}
                    className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-2 px-6 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg">

                      Select Car
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Tempo Traveller Routes Section */}
        <div className="bg-white py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
              Tempo Traveller From Chandigarh
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {tempoRoutes?.map((routeItem, index) =>
              <div
                key={index}
                onClick={() => handleRouteClick(routeItem)}
                className="bg-gray-50 hover:bg-blue-50 border border-gray-200 hover:border-blue-300 rounded-lg p-4 transition-all duration-200 cursor-pointer group">

                  <h3 className="text-sm md:text-base font-semibold text-gray-900 group-hover:text-blue-600 mb-2">
                    {routeItem?.destination}
                  </h3>
                  <p className="text-lg md:text-xl font-bold text-blue-600">{routeItem?.price}</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Visitor's Guide Section */}
        <div className="bg-gray-50 py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
              Visitor's Guide
            </h2>
            {(() => {
              // Create route slug from current route
              const routeSlug = route?.from && route?.to ?
              `${route?.from?.toLowerCase()?.replace(/\s+/g, '-')}-${route?.to?.toLowerCase()?.replace(/\s+/g, '-')}` :
              null;

              const guideContent = null; // Visitor guides will be added in future

              if (guideContent) {
                return (
                  <div className="bg-white rounded-xl shadow-md p-6 md:p-8 space-y-6">
                    <div>
                      <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                        {guideContent?.title}
                      </h3>
                      <p className="text-gray-700 leading-relaxed mb-4">
                        {guideContent?.introduction}
                      </p>
                    </div>
                    <div>
                      <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                        Destination Highlights
                      </h3>
                      <ul className="space-y-3">
                        {guideContent?.highlights?.map((highlight, index) =>
                        <li key={index} className="flex items-start gap-3">
                            <Icon name="MapPin" size={20} className="text-blue-600 mt-1 flex-shrink-0" />
                            <span className="text-gray-700 leading-relaxed">{highlight}</span>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div>
                      <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                        Travel Tips
                      </h3>
                      <ul className="space-y-3">
                        {guideContent?.travelTips?.map((tip, index) =>
                        <li key={index} className="flex items-start gap-3">
                            <Icon name="CheckCircle" size={20} className="text-green-600 mt-1 flex-shrink-0" />
                            <span className="text-gray-700 leading-relaxed">{tip}</span>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div>
                      <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                        Route Information
                      </h3>
                      <p className="text-gray-700 leading-relaxed flex items-start gap-3">
                        <Icon name="Navigation" size={20} className="text-blue-600 mt-1 flex-shrink-0" />
                        <span>{guideContent?.routeInfo}</span>
                      </p>
                    </div>
                    <div>
                      <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                        Why Choose Advait Tour and Travels?
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="flex items-start gap-3">
                          <Icon name="Shield" size={20} className="text-blue-600 mt-1 flex-shrink-0" />
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-1">Safe & Reliable</h4>
                            <p className="text-sm text-gray-600">Well-maintained vehicles with experienced drivers</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-3">
                          <Icon name="DollarSign" size={20} className="text-green-600 mt-1 flex-shrink-0" />
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-1">Best Prices</h4>
                            <p className="text-sm text-gray-600">Competitive rates with no hidden charges</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-3">
                          <Icon name="Clock" size={20} className="text-orange-600 mt-1 flex-shrink-0" />
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-1">24/7 Support</h4>
                            <p className="text-sm text-gray-600">Round-the-clock customer assistance</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-3">
                          <Icon name="Users" size={20} className="text-purple-600 mt-1 flex-shrink-0" />
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-1">Group Travel Experts</h4>
                            <p className="text-sm text-gray-600">Specialized in family and corporate group travel</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>);

              }

              // Fallback generic content if route not found
              return (
                <div className="bg-white rounded-xl shadow-md p-6 md:p-8 space-y-6">
                  <div>
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                      Experience the Adventures of Tempo Traveller from {route?.from} to {route?.to}!
                    </h3>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      Prepare yourself to set off on a unique vacation with Advait Tour and Travels as you travel the picturesque road from {route?.from} to {route?.to}! Our tempo traveller rentals provide the ideal balance of price, comfort, and simplicity, ensuring that every mile of your journey is unforgettable.
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      It might be difficult to plan a vacation from {route?.from} to {route?.to}, but you can put your worries aside when you collaborate with Advait Tour and Travels. Our fleet of immaculate tempo travellers guarantees a comfortable and pleasurable trip, freeing you to unwind and concentrate on taking in the amazing scenery as you go. Whether you're travelling with loved ones, friends, or coworkers, our roomy cars offer plenty of legroom and conveniences to make you feel comfortable all the way.
                    </p>
                    <p className="text-gray-700 leading-relaxed">
                      Convenience is important to Advait Tour and Travels. Our skilled drivers will come to your {route?.from} home or place of business and securely drive you to your destination in {route?.to}, saving you the trouble of figuring out new routes or parking spots. We also guarantee the best value for your money with our competitive and open pricing, making luxury travel affordable for anyone.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                      Choose the Right Tempo Traveller with Advait Tour and Travels
                    </h3>
                    
                    <div className="space-y-4">
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">1. Hire 9 seater Tempo Traveller in {route?.from}</h4>
                        <p className="text-gray-700 leading-relaxed">
                          Want to go somewhere cosy with friends or family? It is ideal to hire a 9 seater Tempo Traveller in {route?.from}. With cosy seats and cool amenities to make your trip to {route?.to} unforgettable, it's like having your own private van. In addition, our friendly driver will guarantee that you arrive without incident.
                        </p>
                      </div>

                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">2. Hire 15 seater Tempo Traveller in {route?.from}</h4>
                        <p className="text-gray-700 leading-relaxed">
                          Have a larger group? Not to worry! Hire a 15 seater Tempo Traveller in {route?.from} that is spacious and comfortable. There's plenty of space for everyone and your equipment. Ideal for large gatherings of friends or family. You may unwind and enjoy the journey while our driver takes care of the driving.
                        </p>
                      </div>

                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">3. 16 seater Tempo Traveller in {route?.from}</h4>
                        <p className="text-gray-700 leading-relaxed">
                          Do you want to travel in luxury? It feels like travelling in a luxurious traveller, but without the luxurious cost, with our 16 seater Tempo Traveller in {route?.from}. With all the bells and whistles needed for a smooth ride, it is incredibly comfortable. You can count on our skilled driver to get you there promptly and safely.
                        </p>
                      </div>

                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">4. Hire 18 seater Tempo Traveller in {route?.from}</h4>
                        <p className="text-gray-700 leading-relaxed">
                          Have even more friends joining you? Hire 18 seater Tempo Traveller in {route?.from} that resembles a large, cosy bus. Lots of room for everyone to spread out and unwind when travelling to {route?.to}. While you relax and enjoy the ride with your loved ones, our driver will take care of the driving.
                        </p>
                      </div>

                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">5. 21 seater Tempo Traveller in {route?.from}</h4>
                        <p className="text-gray-700 leading-relaxed">
                          Have a sizable gathering? It seems like you have your own party on wheels with our 21 seater Tempo Traveller in {route?.from}! It's large, comfortable, and ideal for large families or business travel. Our knowledgeable driver will make sure the trip is easy and entertaining, allowing you to concentrate on creating memories with your party.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                      Premium Tempo Traveller Rentals in {route?.from}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      Advait Tour and Travels provides reasonably priced tempo traveller rental rates in {route?.from}, guaranteeing cost without sacrificing quality. When you hire luxury tempo travellers in {route?.from} on rent, you can enjoy your journey entirely. Our tempo travellers are ideal for long distance travel since they are comfortable, cosy, and furnished with contemporary conveniences to improve your journey. A seamless and pleasurable trip is certain when you hire a tempo traveller from {route?.from} to {route?.to} from Advait Tour and Travels, whether you're organising a corporate event or a family vacation.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                      Why Choose Advait Tour and Travels for Hiring Tempo Travellers?
                    </h3>
                    
                    <div className="space-y-4">
                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">1. Luxury Tempo Traveller in {route?.from}</h4>
                        <p className="text-gray-700 leading-relaxed">
                          At Advait Tour and Travels, we pride ourselves on providing our clients with nothing but the finest. Because of this, we have luxury tempo travellers in our fleet that redefine comfort and style. As soon as you get inside one of our traveller, you'll see how our tempo travellers stand out from the competition thanks to their luxurious design, cutting-edge features, and stylish styling. We recognise that your journey is about more than just travelling from point A to point B; it's also about savouring each and every minute in between. You may travel in elegance and create lifelong experiences with our luxury tempo travellers.
                        </p>
                      </div>

                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">2. Affordable Rates for Luxury Tempo Traveller in {route?.from}</h4>
                        <p className="text-gray-700 leading-relaxed">
                          Although luxury might be expensive, Advait Tour and Travels is dedicated to making it affordable for everybody. We make sure you receive the greatest value for your money by providing our affordable luxury tempo travellers in {route?.from} with rates that are both competitive and reasonable. You may enjoy the better things in life without going over budget with our straightforward and budget-friendly pricing, whether you're planning a weekend trip or a longer vacation. Luxury travel is now a reality with Advait Tour and Travels.
                        </p>
                      </div>

                      <div>
                        <h4 className="text-lg font-semibold text-gray-900 mb-2">3. Book Tempo Traveller in {route?.from} with Ease</h4>
                        <p className="text-gray-700 leading-relaxed">
                          With Advait Tour and Travels, tempo traveller reservations are quick, simple, and hassle-free. To discuss your travel arrangements, just visit our website or give us a call. Our friendly staff will walk you through the booking process. Regardless of whether you want a last-minute transport or are planning ahead, we provide various scheduling choices to meet your needs. You can be confident that your luxury tempo traveller will be prepared and waiting for you at the agreed-upon time and place as soon as your booking is verified. Booking a tempo traveller from {route?.from} with Advait Tour and Travels is only the start of an amazing adventure.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>);

            })()}
          </div>
        </div>

        {/* FAQ Section */}
        <div className="bg-white py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">FAQs</h2>
            <div className="max-w-4xl mx-auto space-y-4">
              {faqData?.map((faq, index) =>
              <FAQItem key={index} question={faq?.question} answer={faq?.answer} />
              )}
            </div>
          </div>
        </div>

        {/* 24/7 Contact Support Section */}
        <ContactSection />
      </div>
      <Footer />
    </div>);


};

export default TempoTravellerDetails;